import { ButtonBase, Menu, MenuItem, Typography } from '@material-ui/core'
import React, { useState } from 'react'

import { getTranslate } from '../../localization'
import { MenuItemInInventory } from '../../types/inventory'

interface InventoryRowMenuProps {
  items: MenuItemInInventory[]
  onChangeSelectedItem?: (fieldType: MenuItemInInventory) => void
  activeItem: string
}

const InventoryRowMenu: React.FC<InventoryRowMenuProps> = ({
  items,
  onChangeSelectedItem,
  activeItem
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const handleOpenMenu = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  const handleChangeMenuItem = (selectedItem: MenuItemInInventory) => {
    onChangeSelectedItem?.(selectedItem)
    handleCloseMenu()
  }

  items.sort((a, b) => a.label.localeCompare(b.label))

  return (
    <>
      <ButtonBase aria-controls="simple-menu" onClick={handleOpenMenu}>
        <Typography variant="h5">
          {getTranslate(activeItem).slice(0, 8)}
          {getTranslate(activeItem).length > 8 ? '...' : ''}
        </Typography>
      </ButtonBase>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}>
        {items.map((mItem) => {
          return (
            <MenuItem
              key={mItem.code}
              value={mItem.code}
              onClick={() => handleChangeMenuItem(mItem)}>
              {getTranslate(mItem.label)}
            </MenuItem>
          )
        })}
      </Menu>
    </>
  )
}

export default InventoryRowMenu
